import { TripOsIdentityAPIClient } from '@talbenmoshe/trip-os-identity-api/client';
import { EmailAddressFormat, SignIn, SignInActivity, SignInCodeFormat, SignInFailure, SignInNotice, SignInStep } from '@talbenmoshe/trip-os-model';
import { LoadingState } from '@zdr-tools/zdr-entities';
import { ResendCountdown } from './sign-in/ResendCountdown.js';
import { SignInFacade } from './sign-in/SignInFacade.js';
import { SignInService } from './sign-in/SignInService.js';
/**
 * Composition root of the login site. Every host capability arrives as a parameter; the client has no base URL, so
 * API calls go to the host the page was loaded from.
 */
export function createTripOsUsersApp(httpClientFactoryCreator, pageNavigator, clock, intervalTimer, returnAddressSource) {
    const httpClient = httpClientFactoryCreator.createFactory().createClient();
    const identityClient = new TripOsIdentityAPIClient(httpClient);
    const signIn = new SignIn({
        step: SignInStep.EMAIL,
        email: '',
        activity: SignInActivity.NONE,
        loadingState: LoadingState.IDLE,
        failure: SignInFailure.NONE,
        attemptsLeft: 0,
        notice: SignInNotice.NONE,
        resendAllowedAt: null,
        secondsUntilResend: 0,
        isCodeUsable: false,
        failureRevision: 0
    });
    return new SignInFacade(signIn, new SignInService(identityClient, returnAddressSource), new EmailAddressFormat(), new SignInCodeFormat(), new ResendCountdown(clock, intervalTimer), pageNavigator);
}
//# sourceMappingURL=createTripOsUsersApp.js.map